// extracted by mini-css-extract-plugin
module.exports = {"cta":"CTAOefeningen-module--cta--22zWN","bergen":"CTAOefeningen-module--bergen--1GKVI","image":"CTAOefeningen-module--image--3Fvlk"};